import React, { memo } from 'react';
import styled from 'styled-components';
import { formatProgressRate, formatProgressCount } from '../utils/utils';
import ProgressBar from './ProgressBar';
import type { CourseProgressItem } from '../types/types';

type CourseProgressListProps = {
	courses: CourseProgressItem[];
};

// 리셉션 상세 - 코스별 현황
const CourseProgressList = memo<CourseProgressListProps>(({ courses }) => {
	return (
		<Wrapper>
			{courses.map(course => (
				<Row key={course.courseName}>
					<CourseName>{course.courseName}</CourseName>
					<ProgressBox>
						<RateText>{formatProgressRate(course.progressRate)}</RateText>
						<ProgressBar rate={course.progressRate} />
						<CountText>{formatProgressCount(course.checkedInCount, course.capacity)}</CountText>
					</ProgressBox>
				</Row>
			))}
		</Wrapper>
	);
});

CourseProgressList.displayName = 'CourseProgressList';

export default CourseProgressList;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
`;
const Row = styled.div`
	display: flex;
	align-items: center;
`;
const ProgressBox = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	flex: 1;
`;
const CourseName = styled.div`
	width: 140px;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.blackColor};
`;
const RateText = styled.div`
	min-width: 56px;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.blackColor};
`;
const CountText = styled.div`
	width: 140px;
	${({ theme }) => theme.typography.body2};
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
`;
